import React from 'react';
import PropTypes from 'prop-types';
import ProductCardStatic from 'components/consumer/ProductCardStatic';
import classNames from 'classnames';
import { imgixDomain } from 'commons/constants';
import ModularCollectionThumbnail from './ModularCollectionThumbnail';

const ModularProductCard = ({
  product,
  displayType = 'collection',
  onClick,
  isFixed = false,
  className = '',
  overrideLink = '',
  thumbnail = '',
}) => {
  if (!product) return null;

  return (
    <>
      {displayType === 'collection' ? (
        <button
          type="button"
          className={classNames('flex items-center cursor-pointer', {
            [className]: className,
            'flex-col': !isFixed,
            'flex-row mx-2 my-0 [border-bottom:2px_solid_#fff]': isFixed,
          })}
          onClick={onClick}
        >
          <div
            className={classNames(
              'flex mx-2 my-0 justify-center [transition:width_.2s_ease-in-out,height_.2s_ease-in-out] w-full',
              {
                'bg-gray-light9 items-center p-4 min-h-[79px] md:w-[162px] md:h-24': !isFixed,
                'bg-white items-start px-0 py-4 min-w-[36px] min-h-[50px] md:w-auto md:h-[52px]': isFixed,
              }
            )}
          >
            <div className="max-w-[70px]">
              <ModularCollectionThumbnail
                image={thumbnail}
                imageSize={isFixed ? 'thumb' : 'modular'}
                isModularSofasPage
              />
            </div>
          </div>
          <div
            className={classNames(
              'font-sans text-base font-bold text-gray-light1 text-center min-h-[23px]',
              {
                'mx-0 my-2': !isFixed,
                'm-2': isFixed,
              }
            )}
          >
            {product.collection}
          </div>
        </button>
      ) : null}

      {displayType === 'product' ? (
        <div
          className={classNames('max-[767px]:flex', {
            [className]: className,
          })}
        >
          <ProductCardStatic
            layout="mini"
            name={product.name}
            variants={product.variants.map(v => ({
              ...v,
              image: `${imgixDomain}${v.image}`,
              path: overrideLink,
            }))}
            variantsToShow={product.variants.map(v => ({
              ...v,
              image: `${imgixDomain}${v.image}`,
              path: overrideLink,
            }))}
            secondaryImage={`${imgixDomain}${product.secondaryImage}`}
            productLabel={product.productLabel}
            path={overrideLink}
          />
        </div>
      ) : null}
    </>
  );
};

ModularProductCard.propTypes = {
  product: PropTypes.object.isRequired,
  displayType: PropTypes.oneOf(['product', 'collection']),
  onClick: PropTypes.func,
  isFixed: PropTypes.bool,
  className: PropTypes.string,
  overrideLink: PropTypes.string,
  thumbnail: PropTypes.string,
};

export default ModularProductCard;
